import { Button } from "../components/ui/button";
import { AlertCircle } from "lucide-react";

const CheckoutCancelledPage = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100">
              <AlertCircle className="h-6 w-6 text-red-600" />
            </div>
            <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
              Payment Cancelled
            </h2>
            <p className="mt-2 text-center text-sm text-gray-600">
              Your payment was cancelled and no charges were made
            </p>
            <div className="mt-6">
              <p className="text-center text-sm text-gray-500">
                No worries! Your cart items are still saved.
                You can continue shopping or try the checkout again.
              </p>
            </div>
            <div className="mt-6 space-y-3">
              <Button
                onClick={() => window.location.href = '/cart'}
                className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
              >
                Return to Cart
              </Button>
              <Button
                onClick={() => window.location.href = '/'}
                variant="outline"
                className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
              >
                Continue Shopping
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Terms & Conditions Page

export { CheckoutCancelledPage };
export default CheckoutCancelledPage;
